import moment from "moment";
import { PRODUCTION_STEPS } from "../constants";

/**
 * Rounds numbers using round half to even (common for accounting)
 * @param {number} num - The number to round
 * @param {number} decimalPlaces - The number of places to round
 */
function evenRound(num, decimalPlaces) {
  const d = decimalPlaces || 0;
  const m = 10 ** d;
  const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
  const i = Math.floor(n);
  const f = n - i;
  const e = 1e-8; // Allow for rounding errors in f
  const r =
    f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n);
  return d ? r / m : r;
}

/**
 * Formats a number as a US currency string
 * @param {number} cents - The number, in cents, to format as money
 */
export function formatPrice(amount, inDollars = false) {
  return `$${evenRound(inDollars ? amount : amount / 100, 2)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export function amountToCents(value) {
  return Math.round(100 * parseFloat(value.replace(/[$,]/g, ""))) || 0;
}

export function contactDisplayName(contact) {
  if (contact.otherFirstName && contact.otherLastName) {
    return contact.lastName === contact.otherLastName
      ? `${contact.firstName} & ${contact.otherFirstName} ${
          contact.otherLastName
        }`
      : `${contact.firstName} ${contact.lastName} & ${contact.otherFirstName} ${
          contact.otherLastName
        }`;
  }

  return `${contact.firstName} ${contact.lastName}`;
}

export function userDisplayName(name) {
  // let splitName = name.split(" ");
  // let firstName = splitName.slice(0, -1).join(" ");
  // let lastInitial = splitName[splitName.length - 1].charAt(0);
  return name;
}

export function measurementDisplay(measurementType) {
  if (measurementType === "measurement_sq_ft") {
    return "sq. ft.";
  } else if (measurementType === "measurement_ln_ft") {
    return "ln. ft.";
  } else {
    return "";
  }
}

export function urlRoot(url) {
  const root = url.match(/^\/[\w-]+/);
  return root ? root[0] : "";
}

export function handleDateFilterChange(
  { component, field, newMoment },
  callback
) {
  if (field === "startDate") {
    component.setState(
      {
        startDate: newMoment,
        endDate: moment.max(newMoment, component.state.endDate)
      },
      callback
    );
  } else if (field === "endDate") {
    component.setState(
      {
        startDate: moment.min(newMoment, component.state.startDate),
        endDate: newMoment
      },
      callback
    );
  }
}

export function orderByArray(array, order, property) {
  return array
    .slice()
    .sort((a, b) => order.indexOf(a[property]) - order.indexOf(b[property]));
}

export function getProductionSteps(service) {
  const steps = PRODUCTION_STEPS[service.serviceType];

  if (steps) {
    return Object.keys(steps)
      .filter(key => {
        const required = steps[key].required;
        return required ? required(service) : true;
      })
      .reduce((acc, key) => ({ ...acc, [key]: steps[key] }), {});
  }

  return {};
}

export function getCurrentProductionStep(service, ordered = false) {
  const allSteps = getProductionSteps(service);
  const orderedSteps = ordered
    ? service.productionSteps
    : orderByArray(service.productionSteps, Object.keys(allSteps), "stepType");
  const stepKeys = Object.keys(allSteps);
  let mostRecentStep = orderedSteps[orderedSteps.length - 1];
  let mostRecentStepIdx = orderedSteps.indexOf(mostRecentStep);

  if (!mostRecentStep) {
    return { info: allSteps[stepKeys[0]], action: "start" };
  } else if (mostRecentStep.completedAt) {
    if (mostRecentStepIdx >= stepKeys.length - 1) {
      return null;
    }

    return {
      info: allSteps[stepKeys[mostRecentStepIdx + 1]],
      action: "start"
    };
  } else if (mostRecentStep.startedAt) {
    return {
      info: allSteps[mostRecentStep.stepType],
      startedAt: mostRecentStep.startedAt,
      user: mostRecentStep.user,
      action: "complete"
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js